import { ifAuthenticated } from '@/router/before'

export const programPages = [
  {
    path: '/programs',
    name: 'ProgramsRoute',
    meta: {
      icon: ['fas', 'list-ul'],
      isDisplayInSidebar: true,
      group: 'Главное',
      displayName: 'Список программ',
    },
    beforeEnter: ifAuthenticated,
    component: () =>
      import(
        /* webpackChunkName: "ProgramsRoute" */ '@/views/programs/ProgramsRoute.vue'
      ),
  },
  {
    path: '/program/:id',
    name: 'ProgramDescriptionRoute',
    meta: {
      icon: ['fas', 'sync'],
      isDisplayInSidebar: false,
      group: 'Программы',
      displayName: 'Страница программы',
    },
    beforeEnter: ifAuthenticated,
    component: () =>
      import(
        /* webpackChunkName: "ProgramDescriptionRoute" */ '@/views/programs/ProgramDescriptionRoute.vue'
      ),
  },
]
